import { createAction, props } from '@ngrx/store';
import {
  MetricControllerFindAllMetric$Params,
  MetricControllerFindAllModelMetric$Params,
} from '../../../api/functions';
import { ILoaderActionPayload } from '../models/loader.model';
import { MetricListResponse, ModelMetricListResponse } from '../../../api/models';

export const metricActions = {
  loadMany: createAction('metric/all/load', props<MetricControllerFindAllMetric$Params>()),
  loadManyDone: createAction('metric/all/done', props<{ state: ILoaderActionPayload; data?: MetricListResponse }>()),
  loadModelMetric: createAction('metric/model/load', props<MetricControllerFindAllModelMetric$Params>()),
  loadModelMetricDone: createAction(
    'metric/model/done',
    props<{ state: ILoaderActionPayload; data?: ModelMetricListResponse }>(),
  ),
};
